// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1497":"68fb61ca","2107":"7def478c","4788":"5b9fa57b"}[chunkId] + ".chunk.css";
};